<template>
  <va-modal
    v-model="toOpenModal"
    :title="$t('modals.user.title')"
    :hideDefaultActions="true"
    :noOutsideDismiss="true"
    :noEscDismiss="true"
  >
    <SwappingSquaresSpinner v-if="modalLoader"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <form v-if="!modalLoader">
      <div class="row">
        <fieldset v-if="showLocation">
          <va-checkbox
            :label="$t('modals.user.checkboxAdmin')"
            v-model="isAdmin"
          />
        </fieldset>
        <va-select v-if="showLocation"
          :disabled="isAdmin"
          style="margin-bottom: 15px;"
          :label="$t('modals.user.selectLocation')"
          v-model="location"
          textBy="name"
          keyBy="eventId"
          :options="locations"
          :error="!!locationError.length"
          class="flex xs12"
        />
        <va-input
          v-model="name"
          type="text"
          :label="$t('modals.user.inputName')"
          :error="!!nameErrors.length"
          :error-messages="nameErrors"
          class="flex xs12"
        />
        <va-input
          v-model="surname"
          type="text"
          :label="$t('modals.user.inputSurname')"
          :error="!!surnameErrors.length"
          :error-messages="surnameErrors"
          class="flex xs12"
        />
        <va-input
          v-model="email"
          type="email"
          :label="$t('modals.user.inputEmail')"
          :error="!!emailErrors.length"
          :error-messages="emailErrors"
          class="flex xs12"
        />
        <va-input
          v-model="password"
          type="password"
          :label="$t('modals.user.inputPassword')"
          :error="!!passwordErrors.length"
          :error-messages="passwordErrors"
          class="flex xs12"
        />
      </div>
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click.prevent="disableModal()" class="my-0 ">{{ $t('modals.user.btnClose') }}</va-button>
        <va-button type="submit" @click.prevent="onsubmit()" class="my-0">{{ $t('modals.user.btnCreate') }}</va-button>
      </div>
    </form>
  </va-modal>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  name: 'UserCreateModal',
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  data () {
    return {
      showLocation: false,
      locations: [],
      modalLoader: false,
      password: '',
      email: '',
      name: '',
      surname: '',
      isAdmin: false,
      location: {},
      emailErrors: [],
      passwordErrors: [],
      passwordAgainErrors: [],
      nameErrors: [],
      surnameErrors: [],
      locationError: [],
    }
  },
  props: {
    locationId: Number,
    openModal: Boolean,
  },
  methods: {
    async createModal () {
      if (!this.locationId) {
        this.showLocation = true
        await this.getTheLocations()
      }
    },
    disableModal () {
      this.password = ''
      this.email = ''
      this.name = ''
      this.surname = ''
      this.isAdmin = false
      this.location = {}
      this.modalLoader = false
      this.emailErrors = []
      this.nameErrors = []
      this.surnameErrors = []
      this.locationError = []
      this.passwordErrors = []
      this.$emit('closemodal', false)
    },
    onsubmit () {
      this.emailErrors = this.email ? [] : [this.$t('modals.user.requiredEmail')]
      this.nameErrors = this.name ? [] : [this.$t('modals.user.requiredName')]
      this.surnameErrors = this.surname ? [] : [this.$t('modals.user.requiredSurname')]
      this.passwordErrors = this.password ? [] : [this.$t('modals.user.requiredPassword')]
      if (!this.isAdmin && !this.locationId) {
        this.locationError = Object.keys(this.location).length !== 0 ? [] : [this.$t('modals.user.requiredLocation')]
      } else {
        this.locationError = []
      }
      if (!this.formUserSubmitReady) {
        return
      }
      this.modalLoader = true
      let locationId = this.locationId
      if (this.showLocation && !this.isAdmin) {
        locationId = this.location.eventId
      }
      this.$store.dispatch('appUserCreate', {
        email: this.email,
        name: this.name,
        surname: this.surname,
        isAdmin: this.isAdmin,
        password: this.password,
        eventId: locationId,
      }).then((resp) => this.afterSubmit(resp.data.message))
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    afterSubmit (user) {
      this.$emit('update', user)
      this.disableModal()
    },
    async getTheLocations () {
      if (this.$store.getters.locations.length === 0) {
        await this.$store.dispatch('getLocations')
          .then(resp => this.initlocations())
          .catch(error => {
            this.errorHandler(error.response)
            this.modalLoader = false
          })
      } else {
        await this.initlocations()
      }
    },
    async initlocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
    },
  },
  computed: {
    toOpenModal () {
      if (this.openModal) {
        this.createModal()
        return true
      } else {
        return false
      }
    },
    formUserSubmitReady () {
      return !(this.emailErrors.length || this.surnameErrors.length || this.nameErrors.length || this.passwordErrors.length || this.locationError.length)
    },
  },
}
</script>

<style scoped>

</style>
